import ButtonIcon from "#common/buttons/ButtonIcon"
import { MasterDialog } from "#common/Dialog/Dialog"
import { InputSelect } from "#common/input/InputSelect"
import { InputSelectAreasMultiple } from "#common/input/InputSelectAreas"
import { useApiSend } from "#hooks/useApiSend"
import SelectCategory from "#training/components/SelectCategory"
import SelectCourse from "#training/components/SelectCourse"
import { useAnnualPlanContext } from "#training/contexts/contexts"
import { UseReload } from "#training/redux/actions"
import { annualPlanDelete, annualPlanPost } from "#training/services/Api"
import AddBoxIcon from "@mui/icons-material/AddBox"
import DeleteSweepIcon from "@mui/icons-material/DeleteSweep"
import {
	Button,
	Checkbox,
	FormControlLabel,
	FormGroup,
	Stack,
	Typography,
} from "@mui/material"
import { MESES } from "Components/Capacitaciones/constants_capacitaciones"
import { Fragment, useEffect, useMemo, useState } from "react"
import { toast } from "react-toastify"
const defaultValue = {
	curso: "",
	category: "",
	month: "",
	areas: "all",
}

const PlanningMassiveDialog = ({ isDeleted = false }) => {
	const { selectCategory } = useAnnualPlanContext()
	const [open, setOpen] = useState(false)
	const [value, setValue] = useState(defaultValue)
	useEffect(() => {
		if (selectCategory?.id)
			setValue({ ...defaultValue, category: selectCategory?.id })
	}, [selectCategory?.id])

	if (!selectCategory?.is_editable) return null
	return (
		<Fragment>
			<ButtonIcon
				title={`${isDeleted ? "Eliminar" : "Crear"} Plan de capacitación masivo`}
				onClick={() => setOpen(true)}
				icon={
					isDeleted ? (
						<DeleteSweepIcon color="error" />
					) : (
						<AddBoxIcon color="success" />
					)
				}
			/>
			<MasterDialog
				{...{
					open,
					setOpen,
					title: `${
						isDeleted ? "Eliminar" : "Crear"
					} Plan de capacitación masivo`,
					// buttons: [{ label: "Eliminar", onClick: () => {} }],
				}}
			>
				<Stack spacing={2}>
					<Typography>Categoría: {selectCategory?.description}</Typography>
					{/* <SelectCategory
						value={value.category}
						setValue={(category) => setValue({ ...value, category })}
						notEdit
					/> */}
					<SelectCourse
						value={value.curso}
						setValue={(curso) => setValue({ ...value, curso })}
					/>
					{!isDeleted && (
						<InputSelect
							label="Mes"
							dataId="id"
							dataLabel="label"
							data={[...MESES]}
							value={value.month ?? ""}
							setValue={(month) => setValue({ ...value, month })}
							fullWidth
						/>
					)}
					<CheckCourses
						{...{ isDeleted, value, setValue, setData: setValue }}
					/>
					<ButtonCreateOrDelete
						{...{ isDeleted, data: value, setData: setValue }}
						text="Crear curso"
					/>
				</Stack>
			</MasterDialog>
		</Fragment>
	)
}
export default PlanningMassiveDialog

const ButtonCreateOrDelete = ({ isDeleted, data, ...props }) => {
	const [disabled, setDisabled] = useState(false)
	const reload = UseReload()
	const success = () => {
		if (typeof props?.setData === "function") props.setData(defaultValue)
		reload()
	}
	const methodApi = useMemo(
		() => (isDeleted ? annualPlanDelete : annualPlanPost),
		[isDeleted]
	)

	const { fetch } = useApiSend(methodApi, {
		success,
		end: () => setDisabled(false),
	})

	if (isDeleted && "month" in data) delete data.month

	const handleSend = () => {
		setDisabled(true)
		for (const campo in data) {
			if (data[campo] === "") {
				toast.error(`Debe completar el campo ${campo}`)
				return
			}
		}
		if (Array.isArray(data.areas) && data.areas.length === 0) {
			toast.error(`Debe seleccionar al menos un departamento`)
			return
		}
		fetch(data)
	}

	return (
		<Button
			disabled={disabled}
			variant="contained"
			color="primary"
			onClick={() => handleSend()}
		>
			{isDeleted ? "Eliminar" : "Crear"} cursos de capacitación
		</Button>
	)
}

const CheckCourses = ({ isDeleted, value, setValue }) => {
	const { selectCategory } = useAnnualPlanContext()
	const [checked, setChecked] = useState(false)
	const handleChange = (event) => {
		const isChecked = event.target.checked
		setChecked(isChecked)
		if (isChecked) setValue({ ...value, areas: "all" })
		else setValue({ ...value, areas: [] })
	}
	useEffect(() => {
		if (value.areas === "all") setChecked(true)
	}, [checked, value.areas])

	if (!selectCategory?.allow_bulk_assignment) return null
	return (
		<FormGroup>
			<FormControlLabel
				control={<Checkbox defaultChecked />}
				label={`${
					isDeleted ? "Eliminar" : "Crear"
				} Curso para todos los departamentos`}
				checked={checked}
				onChange={handleChange}
			/>
			{!checked && (
				<InputSelectAreasMultiple
					value={value.areas}
					setValue={(areas) => setValue({ ...value, areas })}
				/>
			)}
		</FormGroup>
	)
}
